// extracted by mini-css-extract-plugin
export default {"shareIconContainer":"ShareIcon_shareIconContainer__Cw0n0","shareIconSquare":"ShareIcon_shareIconSquare__6iM1Y"};